import React from "react";
import {
  HeaderLanding,
  FooterLanding,
  Features,
  Hero,
  AboutUs,
  Testimonial,
  ContactUs,
  Price,
} from "../../components/index.js";
function LandingPage() {
  return (
    <>
      <HeaderLanding />
      <Hero />
      <AboutUs />
      <Features />
      <Price />
      <Testimonial />
      <ContactUs />
      <FooterLanding />
    </>
  );
}

export default LandingPage;
